import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';

export const BsTooltip = ({
  children,
  content,
}: {
  children: React.ReactNode;
  content: React.ReactNode;
}) => {
  const triggerRef = useRef<HTMLSpanElement | null>(null);
  const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const triggerEl = triggerRef.current;
    if (!triggerEl) {
      return;
    }

    const rootNode = triggerEl.getRootNode();
    if (rootNode instanceof ShadowRoot) {
      const existing = rootNode.querySelector<HTMLElement>('[data-bs-tooltip-portal]');
      if (existing) {
        setPortalContainer(existing);
        return;
      }

      const container = document.createElement('div');
      container.setAttribute('data-bs-tooltip-portal', 'true');
      rootNode.appendChild(container);
      setPortalContainer(container);
      return;
    }

    setPortalContainer(null);
  }, []);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span ref={triggerRef} className="inline-flex">
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent
        portalContainer={portalContainer}
        className="rounded-[4px] bg-[#525867] px-[12px] !py-[7px] text-[12px] text-white leading-normal max-w-[288px] animate-in fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 duration-200"
      >
        {content}
      </TooltipContent>
    </Tooltip>
  );
};
